import { render, staticRenderFns } from "./PCIPassthrough.vue?vue&type=template&id=95e003b4"
import script from "./PCIPassthrough.vue?vue&type=script&lang=js"
export * from "./PCIPassthrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports